import { render, staticRenderFns } from "./FloatingParticles.vue?vue&type=template&id=4af684b0"
import script from "./FloatingParticles.vue?vue&type=script&lang=js"
export * from "./FloatingParticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports